'use client';
import {
  RedeemCode,
  RedeemCodeSkeleton,
} from '@wwe-portal/ui/features/store-revamp/redeem-code';
import { FC } from 'react';

import { useCurrentCurrency } from '@wwe-portal/web/hooks/global/use-current-currency';
import { IcoMoonIcon } from '@wwe-portal/ui/components/icons/icomoon';
import { showDialog } from '@wwe-portal/ui/components/dialog';
import { useTranslations } from 'next-intl';
import { useIsAuthenticated } from '@wwe-portal/web/providers/stores/auth-store';
import { CurrencyData } from '@wwe-portal/entities/offer.type';

import { LoginDialogPortable } from '../auth/login-dialog';
import { ExchangeDialog } from './dialogs/redeem-code';
import { ExchangeCalculatorPortable } from './dialogs/exchange-calculator';

interface ContentProps {
  currency: CurrencyData;
}
const Content: FC<ContentProps> = ({ currency }) => {
  const t = useTranslations();
  const isAuthenticated = useIsAuthenticated();
  const openLoginDialog = () => {
    showDialog(LoginDialogPortable, {
      title: 'Login To Redeem Code',
      isAuthenticated,
    });
  };
  return (
    <RedeemCode
      redeemCodeClick={() => {
        if (!isAuthenticated) {
          openLoginDialog();
          return;
        }

        showDialog(ExchangeDialog);
      }}
      onCalculatorClick={() =>
        showDialog(ExchangeCalculatorPortable, {
          toCurrency: currency.name,
          rate: currency.rate,
        })
      }
      calculatorButtonContent={
        <div className="relative">
          <span className="font-light">1 USD =</span> {currency.rate}{' '}
          <span className="font-normal">
            {t(
              `currency_${currency.name}_${currency.rate === 1 ? 'singular' : 'plural'}`
            )}
          </span>
          <div className="absolute inset-y-0 -right-5 flex size-[14px] items-center">
            <IcoMoonIcon className="size-[14px]" iconName="information-fill" />
          </div>
        </div>
      }
    />
  );
};

export const CurrencyExchange = () => {
  const { isLoading, currency } = useCurrentCurrency();

  if (isLoading || !currency) return <RedeemCodeSkeleton />;
  return <Content currency={currency} />;
};
